/** Runs `worker` over `items` with at most `limit` in flight. `worker` must handle its own errors. */
export async function runWithConcurrency<T>(
    items: T[],
    limit: number,
    worker: (item: T) => Promise<void>,
): Promise<void> {
    let next = 0;
    const runLane = async () => {
        while (next < items.length) {
            await worker(items[next++]);
        }
    };
    await Promise.all(Array.from({ length: Math.min(limit, items.length) }, runLane));
}
